import {observer} from "mobx-react";
import React, {Component} from "react";
import localStyles from "../index.css";
import styles from "../../index.css";
import {Drag, Drop} from "../../../DragNDrop";
import {Truck} from "../../SubComponents";
import {receptionBunkersStore} from "../../../../stores";
import ReceptionDispathcer from "../../../../stores/Dispatcher/ReceptionDispathcer";

@observer
export default class TransportStack extends Component{
    render(){
        const item = this.props.item;
        // const bunker = receptionBunkersStore.receptionBunker;
        const num = this.props.num;
        return(
            <div className={localStyles.queueRow} style={{zIndex:(200+(this.props.transportDrop.bunkerId === num ? 1 : 0))}}>
                {item.transportStack.map((item,i)=>{
                    return(
                        <div className={styles.stackElement} key={i}>
                            {item ?
                                <Drag
                                    style={{height:"100%",width:"100%"}}
                                    onDrag={()=>{this.props.returnTransport(num,i)}}
                                    type={"back,change"}>
                                    <div >
                                        <div>
                                            <div style={{pointerEvents:"none",position:"absolute",zIndex:1,cursor:"pointer"}}>
                                                <Truck
                                                    item={item}
                                                    id={i}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Drag>

                                :
                                null
                            }
                            {!this.props.item.transportStack[3] ?
                                <Drop
                                    className={styles.dropfield+' ' + styles.stackDropfield}
                                    id={i}
                                    onDrop={()=>{
                                        ReceptionDispathcer.addTransportToBunkerStack(num, i,this.props.transportDrop)
                                    }}
                                    type={"truck"}>
                                    <div className={localStyles.dropPlace + ' ' + localStyles.activeTruck} />
                                </Drop>
                                :
                                null
                            }
                            {
                                !this.props.item.transportStack[3] ?
                                    <Drop
                                        className={styles.dropfield+' ' + styles.stackDropfield}
                                        id={i}
                                        onDrop={()=>{
                                            ReceptionDispathcer.switchStack(num,i,this.props.transportDrop,)
                                        }}
                                        type={"change"}>
                                        <div className={localStyles.dropPlace + ' ' + localStyles.activeTruck} />
                                    </Drop>
                                    :
                                    null
                            }
                        </div>
                    )})
                }

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/shared/components/Game/InputFlow/TransportStack/index.js